import React from 'react';
import Container from '@mui/material/Container';
import MedicineCategories from './components/medicinecategories';
import Search from './components/search';
import MedicineList from './components/medicinelist';
import Pagination from './components/pagination';
import './medicine.css';

function Medicine() {
	return (
		<Container
			sx={{
				padding: '40px',
				boxSizing: 'border-box',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Search />
			<MedicineCategories />
			<MedicineList></MedicineList>
			<Pagination />
		</Container >
	);
}

export default Medicine;
